import React, {useMemo} from 'react'
import {HStack, VStack, Text, Skeleton} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'
import {getProductsToAddToCart} from '../../../utils/product-utils'
import ProductDisplayPrice from '../../../components/product-display-price'
import {useCommerceData} from '../../../hooks/use-commerce-data'

const ProductSetCockpitTotal = ({isLoading, product, ...rest}) => {
    const {isEcommerceEnabled} = useCommerceData()
    const totalProducts = useMemo(() => getProductsToAddToCart(product).length, [product])
    return (
        <HStack justify="space-between" {...rest}>
            <VStack justify="start" alignItems="flex-start" spacing={0.5}>
                <Text as="h2" textStyle="Regular 2XLarge">
                    <FormattedMessage id="global.total" defaultMessage="Total" />
                </Text>
                <Skeleton isLoaded={!isLoading}>
                    <Text textStyle="Regular Small">
                        <FormattedMessage
                            id="product_set_detail.cockpit.product-count"
                            defaultMessage="{totalProducts} products"
                            values={{totalProducts}}
                        />
                    </Text>
                </Skeleton>
            </VStack>
            {isEcommerceEnabled && (
                <VStack alignItems="flex-end" spacing={0}>
                    <ProductDisplayPrice product={product} loading={isLoading} variant="psdp" />
                </VStack>
            )}
        </HStack>
    )
}

ProductSetCockpitTotal.propTypes = {
    isLoading: PropTypes.bool,
    product: PropTypes.object
}
export default ProductSetCockpitTotal
